import {
    capitalize,
    capitalizeAll,
} from '@superbet-group/web.lib.utilities';

import i18n from '@app/localization/i18n';
import { RouteIdentity } from '@app/router/types';

const noTitle = '#no-title';
const emptyTitle = '';
const lotteryTitle = i18n.t('Lottery betting - Greece Kino, Win for Life, Numerone').toString();
const sportTitle = i18n.t('Sports and live betting').toString();

export const freeToPlayGameTitlePrefix = 'freeToPlay_game_title';

export const gamesTitle = i18n.t('Games - slot machines, poker, roulette').toString();

export const Title: RouteIdentity<string> = {
    App: {
        Home: sportTitle,
        Info: capitalize(i18n.t('info').toString()),
        Wiki: 'Wiki',
        NotFound: capitalize(i18n.t('page not found').toString()),
        NotAuthorized: capitalize(i18n.t('page not authorized').toString()),
        TermsAndConditions: noTitle,
        CatchAll: noTitle,
        IdCardVerificationCaptive: capitalize(i18n.t('verify identity').toString()),
        VerifyPhoneCaptive: capitalize(i18n.t('verify phone').toString()),
    },
    Account: {
        Container: emptyTitle, // empty on purpose
        PaymentGatewayStatus: capitalize(i18n.t('transaction status').toString()),
        Activate: capitalize(i18n.t('activate account').toString()),
        Profile: capitalize(i18n.t('profile page').toString()),
        PasswordRecovery: capitalize(i18n.t('forgot password').toString()),
        ForgotPassword: capitalize(i18n.t('forgot password').toString()),
        Recovery: capitalize(i18n.t('pam.routes.pageTitle.accountRecovery').toString()),
        Register: capitalize(i18n.t('register').toString()),
        ResendActivationEmail: capitalize(i18n.t('register').toString()),
        ContinueRegistration: capitalize(i18n.t('pam.routes.pageTitle.continueRegistration').toString()),
        Deposit: capitalize(i18n.t('deposit').toString()),
        History: capitalize(i18n.t('history').toString()),
        Settings: capitalize(i18n.t('settings').toString()),
        Withdrawal: capitalize(i18n.t('withdrawal').toString()),
        DocumentUpload: capitalize(i18n.t('document upload').toString()),
        IdentityVerification: capitalize(i18n.t('identity verification').toString()),
        IdentityVerificationUploadAdditional: capitalize(i18n.t('document upload').toString()),
        ResponsibleGaming: noTitle,
        DepositLimit: noTitle,
        BettingLimit: noTitle,
        LossLimit: noTitle,
        SessionLimit: noTitle,
        SelfExclusion: noTitle,
        TimeOut: noTitle,
        AccountClosure: noTitle,
        RealityCheck: noTitle,
        MyMessages: capitalize(i18n.t('bonus_comms.inbox.my_messages').toString()),
        ChangePhone: capitalize(i18n.t('pam.account.changePhoneNumber').toString()),
        ReferAFriend: capitalize(i18n.t('raf.title').toString()),
        HelpAndSupport: capitalize(i18n.t('pam.account.helpAndSupport').toString()),
        ChatPlaceholder: capitalize(i18n.t('chat').toString()),
        MySocial: capitalize(i18n.t('pam.accountMenu.mySocial').toString()),
        EditMySocial: capitalize(i18n.t('pam.accountMenu.editMySocial').toString()),
        BlockedUsers: capitalize(i18n.t('social.user_profile.settings.blocked_users.title').toString()),
        MyAccount: capitalize(i18n.t('my account').toString()),
        ChangePassword: capitalize(i18n.t('change password').toString()),
        SettingsBetslip: capitalize(i18n.t('settings').toString()),
        SwitchLanguage: capitalize(i18n.t('switch language').toString()),
        SwitchTheme: capitalize(i18n.t('switch theme').toString()),
        LicencePreferences: capitalize(i18n.t('licence preferences').toString()),
        LoginHistory: noTitle,
        AccountSecurity: capitalize(i18n.t('pam.security.accountSecurity').toString()),
    },
    Sport: {
        OfferEvent: sportTitle,
        PrematchOffer: sportTitle,
        BetSlip: noTitle,
        Filter: noTitle,
        Search: sportTitle,
        Favourites: sportTitle,
        Category: sportTitle,
        CategoryPerTime: sportTitle,
        SportCompetitions: sportTitle,
        Competition: sportTitle,
        EventRedirect: i18n.t('Redirecting to event ...').toString(),
        TournamentRedirect: i18n.t('Redirecting to tournament ...').toString(),
        CategoryRedirect: i18n.t('Redirecting to category ...').toString(),
        SuperAdvantage: i18n.t('super advantage').toString(),
        PriceBoost: i18n.t('generosity.priceboost.title').toString(),
        MultiEventBetBuilder: i18n.t('betBuilder.multiEvent.page.title').toString(),
        PopularBets: 'Popular Bets',
        TopWinners: i18n.t('op.top_winners').toString(),
        Social: i18n.t('social.social_section.title').toString(),
    },
    Lottery: {
        Offer: lotteryTitle,
    },
    News: {
        Feed: capitalize(i18n.t('news').toString()),
        Article: noTitle,
        Articles: i18n.t('Latest news in world of sport').toString(),
    },
    Free2Play: {
        BingoBash: 'Bingo Bash',
        SuperSpin: 'Super spin',
        FreeGamesInfo: capitalizeAll(i18n.t('free games').toString()),
        SportCaller: capitalizeAll(i18n.t('sport caller title').toString()),
        SuperMillion: capitalizeAll(i18n.t('superMillion.title').toString()),
        CalendarGame: noTitle,
        SuperShot: capitalizeAll(i18n.t('super shot').toString()),
        TopManager: noTitle,
        FantasticDuels: capitalizeAll(i18n.t('fantasticDuels.title').toString()),
    },
    GrowthMarketing: {
        LandingIntro: sportTitle,
        PromotionsInfo: capitalize(i18n.t('bonuses promotions').toString()),
        NewBettingSiteSerbia: 'Postali smo SUPER',
    },
    Native: {
        AppsFooter: noTitle,
        Wiki: emptyTitle,
    },
    BonusAndComms: {
        LpBonus: noTitle,
        PromotionHub: capitalize(i18n.t('bonus_comms.promotion_hub_title').toString()),
        Notifications: capitalize(i18n.t('pam.accountMenu.notifications').toString()),
        MarketingConsent: capitalize(i18n.t('settings.privacyPolicy').toString()),
    },
    Loyalty: {
        Supercoins: capitalize(i18n.t('loyalty.supercoins.title').toString()),
    },
};
